import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type AIActionTypes = "AUTOFILL_CONFIRM" | "AUTOFILL_CANCEL" | "AUTOFILL_ERROR";

// Define types the state
export type AIDataState = {
  aiAutoFillRequested: number | null;
  aiFillRequestStarted: number | null;
  handledAIFillRequestStarted: number | null;
  aiFillRequestCompleted: number | null;
  showDismissedChanges: boolean;
  confirmedActionType: AIActionTypes | null;
};

const aiDataSlice = createSlice({
  name: "data", // Name of the slice
  initialState: {
    aiAutoFillRequested: null,
    aiFillRequestStarted: null,
    handledAIFillRequestStarted: null,
    aiFillRequestCompleted: null,
    showDismissedChanges: false,
    confirmedActionType: null,
  },

  reducers: {
    // This is an example of [type] syntax in a reducer function
    setAIAutoFillRequested: (state, action) => {
      state.aiAutoFillRequested = action.payload;
    },
    setAIRequestStarted: (state, action) => {
      state.aiFillRequestStarted = action.payload;
    },
    setHandledAIFillRequestStarted(state, action) {
      state.handledAIFillRequestStarted = action.payload;
    },
    setAIRequestCompleted: (state, action) => {
      state.aiFillRequestCompleted = action.payload;
    },
    setShowDismissedChanges: (state, action: PayloadAction<boolean>) => {
      state.showDismissedChanges = action.payload;
    },
    setConfirmedActionType: (state, action: PayloadAction<AIActionTypes | null>) => {
      state.confirmedActionType = action.payload as any;
    },
    resetAISlice: (state) => {
      state.aiAutoFillRequested = null;
      state.aiFillRequestStarted = null;
      state.aiFillRequestCompleted = null;
      state.handledAIFillRequestStarted = null;
      state.showDismissedChanges = false;
      state.confirmedActionType = null;
    },
  },
});

export const {
  setAIAutoFillRequested,
  setAIRequestStarted,
  setHandledAIFillRequestStarted,
  setAIRequestCompleted,
  setShowDismissedChanges,
  setConfirmedActionType,
  resetAISlice,
} = aiDataSlice.actions;
export default aiDataSlice.reducer;
